import { render, staticRenderFns } from "./Parent.vue?vue&type=template&id=49a2694a&scoped=true&lang=pug"
import script from "./Parent.vue?vue&type=script&lang=js"
export * from "./Parent.vue?vue&type=script&lang=js"
import style0 from "./Parent.styl?vue&type=style&index=0&id=49a2694a&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a2694a",
  null
  
)

export default component.exports